import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { ListInstructorsOrTutorsDTO } from 'src/app/model/newModel';
import { InstructorsService } from './instructors.service';

@Component({
  selector: 'app-instructors',
  templateUrl: './instructors.component.html',
  styleUrls: ['./instructors.component.css'],
})
export class InstructorsComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  listInstructors: ListInstructorsOrTutorsDTO;

  ngOnInit(): void {
    super.ngOnInit();
    this.spinner.show();
    this.instructorsService.search().subscribe(
      (result) => {
        this.spinner.hide();
        this.listInstructors = result;
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  goToInstructorDetail(idInstructor: number) {
    this.router.navigate(['/instructor'], {
      queryParams: { idInstructor: idInstructor },
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    public router: Router,
    private instructorsService: InstructorsService
  ) {
    super();
  }

  nextPage(skip: number, take: number, count: number) {
    this.instructorsService.nextPage(skip, take, count).subscribe(
      (result) => {
        this.listInstructors = result;
      },
      (error) => {
        console.log('Errore search next');
      }
    );
  }

  previousPage(skip: number, take: number) {
    this.instructorsService.previousPage(skip, take).subscribe(
      (result) => {
        this.listInstructors = result;
      },
      (error) => {
        console.log('Errore search previous');
      }
    );
  }
}
